export default [
  { name: 'Japan', displayName: '日本', disabled: false },
  { name: 'United Kingdom', displayName: '英国', disabled: false },
  { name: 'United States', displayName: '米国', disabled: false },
  { name: 'Australia', displayName: 'オーストラリア', disabled: false },
  { name: 'Canada', displayName: 'カナダ', disabled: false },
  { name: 'France', displayName: 'フランス', disabled: false },
  { name: 'Germany', displayName: 'ドイツ', disabled: false },
  { name: 'Spain', displayName: 'スペイン', disabled: false },
  { name: 'China', displayName: '中国', disabled: false },
  { name: null, displayName: '---', disabled: true },
  { name: 'Afghanistan', displayName: 'アフガニスタン', disabled: false },
  { name: 'Åland Islands', displayName: 'Åland Islands', disabled: false },
  { name: 'Albania', displayName: 'アルバニア', disabled: false },
  { name: 'Algeria', displayName: 'アルジェリア', disabled: false },
  { name: 'American Samoa', displayName: 'American Samoa', disabled: false },
  { name: 'Andorra', displayName: 'アンドラ', disabled: false },
  { name: 'Angola', displayName: 'アンゴラ', disabled: false },
  { name: 'Anguilla', displayName: 'Anguilla', disabled: false },
  { name: 'Antarctica', displayName: 'Antarctica', disabled: false },
  {
    name: 'Antigua & Barbuda',
    displayName: 'Antigua & Barbuda',
    disabled: false,
  },
  { name: 'Argentina', displayName: 'アルゼンチン', disabled: false },
  { name: 'Armenia', displayName: 'アルメニア', disabled: false },
  { name: 'Aruba', displayName: 'Aruba', disabled: false },
  {
    name: 'Ascension Island',
    displayName: 'Ascension Island',
    disabled: false,
  },
  { name: 'Austria', displayName: 'オーストリア', disabled: false },
  { name: 'Azerbaijan', displayName: 'アゼルバイジャン', disabled: false },
  { name: 'Bahamas', displayName: 'バハマ', disabled: false },
  { name: 'Bahrain', displayName: 'バーレーン', disabled: false },
  { name: 'Bangladesh', displayName: 'バングラデシュ', disabled: false },
  { name: 'Barbados', displayName: 'バルバドス', disabled: false },
  { name: 'Belarus', displayName: 'ベラルーシ', disabled: false },
  { name: 'Belgium', displayName: 'ベルギー', disabled: false },
  { name: 'Belize', displayName: 'ベリーズ', disabled: false },
  { name: 'Benin', displayName: 'ベナン', disabled: false },
  { name: 'Bermuda', displayName: 'Bermuda', disabled: false },
  { name: 'Bhutan', displayName: 'ブータン', disabled: false },
  { name: 'Bolivia', displayName: 'ボリビア', disabled: false },
  {
    name: 'Bosnia & Herzegovina',
    displayName: 'Bosnia & Herzegovina',
    disabled: false,
  },
  { name: 'Botswana', displayName: 'ボツワナ', disabled: false },
  { name: 'Brazil', displayName: 'ブラジル', disabled: false },
  {
    name: 'British Indian Ocean Territory',
    displayName: 'British Indian Ocean Territory',
    disabled: false,
  },
  {
    name: 'British Virgin Islands',
    displayName: 'British Virgin Islands',
    disabled: false,
  },
  { name: 'Brunei', displayName: 'ブルネイ', disabled: false },
  { name: 'Bulgaria', displayName: 'ブルガリア', disabled: false },
  { name: 'Burkina Faso', displayName: 'Burkina Faso', disabled: false },
  { name: 'Burundi', displayName: 'ブルンジ', disabled: false },
  { name: 'Cambodia', displayName: 'カンボジア', disabled: false },
  { name: 'Cameroon', displayName: 'カメルーン', disabled: false },
  { name: 'Canary Islands', displayName: 'Canary Islands', disabled: false },
  { name: 'Cape Verde', displayName: 'カーボベルデ', disabled: false },
  {
    name: 'Caribbean Netherlands',
    displayName: 'Caribbean Netherlands',
    disabled: false,
  },
  { name: 'Cayman Islands', displayName: 'Cayman Islands', disabled: false },
  {
    name: 'Central African Republic',
    displayName: '中央アフリカ共和国',
    disabled: false,
  },
  { name: 'Ceuta & Melilla', displayName: 'Ceuta & Melilla', disabled: false },
  { name: 'Chad', displayName: 'チャド', disabled: false },
  { name: 'Chile', displayName: 'チリ', disabled: false },
  {
    name: 'Christmas Island',
    displayName: 'Christmas Island',
    disabled: false,
  },
  {
    name: 'Cocos (Keeling) Islands',
    displayName: 'Cocos (Keeling) Islands',
    disabled: false,
  },
  { name: 'Colombia', displayName: 'コロンビア', disabled: false },
  { name: 'Comoros', displayName: 'コモロ', disabled: false },
  {
    name: 'Congo - Brazzaville',
    displayName: 'Congo - Brazzaville',
    disabled: false,
  },
  {
    name: 'Congo - Kinshasa',
    displayName: 'Congo - Kinshasa',
    disabled: false,
  },
  { name: 'Cook Islands', displayName: 'Cook Islands', disabled: false },
  { name: 'Costa Rica', displayName: 'コスタリカ', disabled: false },
  { name: 'Côte d’Ivoire', displayName: 'Côte d’Ivoire', disabled: false },
  { name: 'Croatia', displayName: 'クロアチア', disabled: false },
  { name: 'Cuba', displayName: 'キューバ', disabled: false },
  { name: 'Curaçao', displayName: 'Curaçao', disabled: false },
  { name: 'Cyprus', displayName: 'キプロス', disabled: false },
  { name: 'Czech Republic', displayName: 'チェコ共和国', disabled: false },
  { name: 'Denmark', displayName: 'デンマーク', disabled: false },
  { name: 'Diego Garcia', displayName: 'Diego Garcia', disabled: false },
  { name: 'Djibouti', displayName: 'ジブチ', disabled: false },
  { name: 'Dominica', displayName: 'ドミニカ', disabled: false },
  {
    name: 'Dominican Republic',
    displayName: 'ドミニカ共和国',
    disabled: false,
  },
  { name: 'Ecuador', displayName: 'エクアドル', disabled: false },
  { name: 'Egypt', displayName: 'エジプト', disabled: false },
  { name: 'El Salvador', displayName: 'エルサルバドル', disabled: false },
  { name: 'Equatorial Guinea', displayName: '赤道ギニア', disabled: false },
  { name: 'Eritrea', displayName: 'エリトリア', disabled: false },
  { name: 'Estonia', displayName: 'エストニア', disabled: false },
  { name: 'Ethiopia', displayName: 'エチオピア', disabled: false },
  {
    name: 'Falkland Islands',
    displayName: 'Falkland Islands',
    disabled: false,
  },
  { name: 'Faroe Islands', displayName: 'Faroe Islands', disabled: false },
  { name: 'Fiji', displayName: 'フィジー', disabled: false },
  { name: 'Finland', displayName: 'フィンランド', disabled: false },
  { name: 'French Guiana', displayName: 'French Guiana', disabled: false },
  {
    name: 'French Polynesia',
    displayName: 'French Polynesia',
    disabled: false,
  },
  {
    name: 'French Southern Territories',
    displayName: 'French Southern Territories',
    disabled: false,
  },
  { name: 'Gabon', displayName: 'ガボン', disabled: false },
  { name: 'Gambia', displayName: 'ガンビア', disabled: false },
  { name: 'Georgia', displayName: 'グルジア', disabled: false },
  { name: 'Ghana', displayName: 'ガーナ', disabled: false },
  { name: 'Gibraltar', displayName: 'Gibraltar', disabled: false },
  { name: 'Greece', displayName: 'ギリシャ', disabled: false },
  { name: 'Greenland', displayName: 'Greenland', disabled: false },
  { name: 'Grenada', displayName: 'グレナダ', disabled: false },
  { name: 'Guadeloupe', displayName: 'Guadeloupe', disabled: false },
  { name: 'Guam', displayName: 'Guam', disabled: false },
  { name: 'Guatemala', displayName: 'グアテマラ', disabled: false },
  { name: 'Guernsey', displayName: 'Guernsey', disabled: false },
  { name: 'Guinea', displayName: 'ギニア', disabled: false },
  { name: 'Guinea-Bissau', displayName: 'ギニアビサウ', disabled: false },
  { name: 'Guyana', displayName: 'ガイアナ', disabled: false },
  { name: 'Haiti', displayName: 'ハイチ', disabled: false },
  { name: 'Honduras', displayName: 'ホンジュラス', disabled: false },
  { name: 'Hong Kong', displayName: 'Hong Kong', disabled: false },
  { name: 'Hungary', displayName: 'ハンガリー', disabled: false },
  { name: 'Iceland', displayName: 'アイスランド', disabled: false },
  { name: 'India', displayName: 'インド', disabled: false },
  { name: 'Indonesia', displayName: 'インドネシア', disabled: false },
  { name: 'Iran', displayName: 'イラン', disabled: false },
  { name: 'Iraq', displayName: 'イラク', disabled: false },
  { name: 'Ireland', displayName: 'アイルランド', disabled: false },
  { name: 'Isle of Man', displayName: 'Isle of Man', disabled: false },
  { name: 'Israel', displayName: 'イスラエル', disabled: false },
  { name: 'Italy', displayName: 'イタリア', disabled: false },
  { name: 'Jamaica', displayName: 'ジャマイカ', disabled: false },
  { name: 'Jersey', displayName: 'Jersey', disabled: false },
  { name: 'Jordan', displayName: 'ヨルダン', disabled: false },
  { name: 'Kazakhstan', displayName: 'カザフスタン', disabled: false },
  { name: 'Kenya', displayName: 'ケニア', disabled: false },
  { name: 'Kiribati', displayName: 'キリバス', disabled: false },
  { name: 'Kosovo', displayName: 'コソボ', disabled: false },
  { name: 'Kuwait', displayName: 'クウェート', disabled: false },
  { name: 'Kyrgyzstan', displayName: 'キルギスタン', disabled: false },
  { name: 'Laos', displayName: 'ラオス', disabled: false },
  { name: 'Latvia', displayName: 'ラトビア', disabled: false },
  { name: 'Lebanon', displayName: 'レバノン', disabled: false },
  { name: 'Lesotho', displayName: 'レソト', disabled: false },
  { name: 'Liberia', displayName: 'リベリア', disabled: false },
  { name: 'Libya', displayName: 'リビア', disabled: false },
  { name: 'Liechtenstein', displayName: 'リヒテンシュタイン', disabled: false },
  { name: 'Lithuania', displayName: 'リトアニア', disabled: false },
  { name: 'Luxembourg', displayName: 'ルクセンブルク', disabled: false },
  { name: 'Macau SAR China', displayName: 'Macau SAR China', disabled: false },
  { name: 'Macedonia', displayName: 'マケドニア', disabled: false },
  { name: 'Madagascar', displayName: 'マダガスカル', disabled: false },
  { name: 'Malawi', displayName: 'マラウイ', disabled: false },
  { name: 'Malaysia', displayName: 'マレーシア', disabled: false },
  { name: 'Maldives', displayName: 'モルディブ', disabled: false },
  { name: 'Mali', displayName: 'マリ', disabled: false },
  { name: 'Malta', displayName: 'マルタ', disabled: false },
  { name: 'Marshall Islands', displayName: 'マーシャル諸島', disabled: false },
  { name: 'Martinique', displayName: 'Martinique', disabled: false },
  { name: 'Mauritania', displayName: 'モーリタニア', disabled: false },
  { name: 'Mauritius', displayName: 'モーリシャス', disabled: false },
  { name: 'Mayotte', displayName: 'Mayotte', disabled: false },
  { name: 'Mexico', displayName: 'メキシコ', disabled: false },
  { name: 'Micronesia', displayName: 'ミクロネシア', disabled: false },
  { name: 'Moldova', displayName: 'モルドバ', disabled: false },
  { name: 'Monaco', displayName: 'モナコ', disabled: false },
  { name: 'Mongolia', displayName: 'モンゴル', disabled: false },
  { name: 'Montenegro', displayName: 'モンテネグロ', disabled: false },
  { name: 'Montserrat', displayName: 'Montserrat', disabled: false },
  { name: 'Morocco', displayName: 'モロッコ', disabled: false },
  { name: 'Mozambique', displayName: 'モザンビーク', disabled: false },
  { name: 'Myanmar (Burma)', displayName: 'Myanmar (Burma)', disabled: false },
  { name: 'Namibia', displayName: 'ナミビア', disabled: false },
  { name: 'Nauru', displayName: 'ナウル', disabled: false },
  { name: 'Nepal', displayName: 'ネパール', disabled: false },
  { name: 'Netherlands', displayName: 'オランダ', disabled: false },
  { name: 'New Caledonia', displayName: 'New Caledonia', disabled: false },
  { name: 'New Zealand', displayName: 'ニュージーランド', disabled: false },
  { name: 'Nicaragua', displayName: 'ニカラグア', disabled: false },
  { name: 'Niger', displayName: 'ニジェール', disabled: false },
  { name: 'Nigeria', displayName: 'ナイジェリア', disabled: false },
  { name: 'Niue', displayName: 'Niue', disabled: false },
  { name: 'Norfolk Island', displayName: 'Norfolk Island', disabled: false },
  { name: 'North Korea', displayName: '北朝鮮', disabled: false },
  {
    name: 'Northern Mariana Islands',
    displayName: 'Northern Mariana Islands',
    disabled: false,
  },
  { name: 'Norway', displayName: 'ノルウェー', disabled: false },
  { name: 'Oman', displayName: 'オマーン', disabled: false },
  { name: 'Pakistan', displayName: 'パキスタン', disabled: false },
  { name: 'Palau', displayName: 'パラオ', disabled: false },
  {
    name: 'Palestinian Territories',
    displayName: 'パレスチナ地区',
    disabled: false,
  },
  { name: 'Panama', displayName: 'パナマ', disabled: false },
  {
    name: 'Papua New Guinea',
    displayName: 'パプアニューギニア',
    disabled: false,
  },
  { name: 'Paraguay', displayName: 'パラグアイ', disabled: false },
  { name: 'Peru', displayName: 'ペルー', disabled: false },
  { name: 'Philippines', displayName: 'フィリピン', disabled: false },
  {
    name: 'Pitcairn Islands',
    displayName: 'Pitcairn Islands',
    disabled: false,
  },
  { name: 'Poland', displayName: 'ポーランド', disabled: false },
  { name: 'Portugal', displayName: 'ポルトガル', disabled: false },
  { name: 'Puerto Rico', displayName: 'Puerto Rico', disabled: false },
  { name: 'Qatar', displayName: 'カタール', disabled: false },
  { name: 'Réunion', displayName: 'Réunion', disabled: false },
  { name: 'Romania', displayName: 'ルーマニア', disabled: false },
  { name: 'Russia', displayName: 'ロシア', disabled: false },
  { name: 'Rwanda', displayName: 'ルワンダ', disabled: false },
  { name: 'Samoa', displayName: 'サモア', disabled: false },
  { name: 'San Marino', displayName: 'サンマリノ', disabled: false },
  {
    name: 'São Tomé & Príncipe',
    displayName: 'São Tomé & Príncipe',
    disabled: false,
  },
  { name: 'Saudi Arabia', displayName: 'サウジアラビア', disabled: false },
  { name: 'Senegal', displayName: 'セネガル', disabled: false },
  { name: 'Serbia', displayName: 'セルビア', disabled: false },
  { name: 'Seychelles', displayName: 'セイシェル', disabled: false },
  { name: 'Sierra Leone', displayName: 'Sierra Leone', disabled: false },
  { name: 'Singapore', displayName: 'シンガポール', disabled: false },
  { name: 'Sint Maarten', displayName: 'Sint Maarten', disabled: false },
  { name: 'Slovakia', displayName: 'スロバキア', disabled: false },
  { name: 'Slovenia', displayName: 'スロベニア', disabled: false },
  { name: 'Solomon Islands', displayName: 'ソロモン諸島', disabled: false },
  { name: 'Somalia', displayName: 'ソマリア', disabled: false },
  { name: 'South Africa', displayName: '南アフリカ', disabled: false },
  {
    name: 'South Georgia & South Sandwich Islands',
    displayName: 'South Georgia & South Sandwich Islands',
    disabled: false,
  },
  { name: 'South Korea', displayName: '韓国', disabled: false },
  { name: 'South Sudan', displayName: 'South Sudan', disabled: false },
  { name: 'Sri Lanka', displayName: 'スリランカ', disabled: false },
  { name: 'St. Barthélemy', displayName: 'St. Barthélemy', disabled: false },
  { name: 'St. Helena', displayName: 'St. Helena', disabled: false },
  {
    name: 'St. Kitts & Nevis',
    displayName: 'St. Kitts & Nevis',
    disabled: false,
  },
  { name: 'St. Lucia', displayName: 'St. Lucia', disabled: false },
  { name: 'St. Martin', displayName: 'St. Martin', disabled: false },
  {
    name: 'St. Pierre & Miquelon',
    displayName: 'St. Pierre & Miquelon',
    disabled: false,
  },
  {
    name: 'St. Vincent & Grenadines',
    displayName: 'St. Vincent & Grenadines',
    disabled: false,
  },
  { name: 'Sudan', displayName: 'スーダン', disabled: false },
  { name: 'Suriname', displayName: 'スリナム', disabled: false },
  {
    name: 'Svalbard & Jan Mayen',
    displayName: 'Svalbard & Jan Mayen',
    disabled: false,
  },
  { name: 'Swaziland', displayName: 'スワジランド', disabled: false },
  { name: 'Sweden', displayName: 'スウェーデン', disabled: false },
  { name: 'Switzerland', displayName: 'スイス', disabled: false },
  { name: 'Syria', displayName: 'シリア', disabled: false },
  { name: 'Taiwan', displayName: '台湾', disabled: false },
  { name: 'Tajikistan', displayName: 'タジキスタン', disabled: false },
  { name: 'Tanzania', displayName: 'タンザニア', disabled: false },
  { name: 'Thailand', displayName: 'タイ', disabled: false },
  { name: 'Timor-Leste', displayName: '東ティモール', disabled: false },
  { name: 'Togo', displayName: 'トーゴ', disabled: false },
  { name: 'Tokelau', displayName: 'Tokelau', disabled: false },
  { name: 'Tonga', displayName: 'トンガ', disabled: false },
  {
    name: 'Trinidad & Tobago',
    displayName: 'Trinidad & Tobago',
    disabled: false,
  },
  {
    name: 'Tristan da Cunha',
    displayName: 'Tristan da Cunha',
    disabled: false,
  },
  { name: 'Tunisia', displayName: 'チュニジア', disabled: false },
  { name: 'Turkey', displayName: 'トルコ', disabled: false },
  { name: 'Turkmenistan', displayName: 'トルクメニスタン', disabled: false },
  {
    name: 'Turks & Caicos Islands',
    displayName: 'Turks & Caicos Islands',
    disabled: false,
  },
  { name: 'Tuvalu', displayName: 'ツバル', disabled: false },
  {
    name: 'U.S. Outlying Islands',
    displayName: 'U.S. Outlying Islands',
    disabled: false,
  },
  {
    name: 'U.S. Virgin Islands',
    displayName: 'U.S. Virgin Islands',
    disabled: false,
  },
  { name: 'Uganda', displayName: 'Uganda', disabled: false },
  { name: 'Ukraine', displayName: 'Ukraine', disabled: false },
  {
    name: 'United Arab Emirates',
    displayName: 'アラブ首長国連邦',
    disabled: false,
  },
  { name: 'Uruguay', displayName: 'ウルグアイ', disabled: false },
  { name: 'Uzbekistan', displayName: 'ウズベキスタン', disabled: false },
  { name: 'Vanuatu', displayName: 'バヌアツ', disabled: false },
  { name: 'Vatican City', displayName: 'Vatican City', disabled: false },
  { name: 'Venezuela', displayName: 'ベネズエラ', disabled: false },
  { name: 'Vietnam', displayName: 'ベトナム', disabled: false },
  { name: 'Wallis & Futuna', displayName: 'Wallis & Futuna', disabled: false },
  { name: 'Western Sahara', displayName: 'Western Sahara', disabled: false },
  { name: 'Yemen', displayName: 'イエメン', disabled: false },
  { name: 'Zambia', displayName: 'ザンビア', disabled: false },
  { name: 'Zimbabwe', displayName: 'ジンバブエ', disabled: false },
];
